export const colors = {
  // Main backgrounds
  background: '#ffffff', // White background for retro theme
  surface: '#f8f8f8', // Slightly off-white for surfaces
  surfaceLight: '#eeeeee', // Light gray for elevated surfaces
  
  // Text colors
  headline: '#000000', // Black headlines for retro theme
  paragraph: '#333333', // Dark gray for paragraph text
  textMuted: '#666666', // Muted gray text
  
  // Primary colors - Teal represents growth and learning
  primary: '#ffff00', // Vibrant yellow for primary actions
  primaryHover: '#cccc00', // Darker yellow for hover
  primaryMuted: '#ffff99', // Light yellow for subtle elements
  
  // Secondary colors - Complementary to teal
  secondary: '#000000', // Black for secondary actions
  secondaryHover: '#333333', // Darker black for hover
  secondaryMuted: '#cccccc', // Light gray for muted secondary elements
  
  // Accent colors - For highlights and emphasis
  accent: '#ffff00', // Yellow for accents
  accentHover: '#cccc00', // Darker yellow for accent hover
  accentMuted: '#ffff99', // Light yellow for muted accents
  
  // Status colors - Clear and intuitive
  success: '#059669',        // Green - success states
  successHover: '#047857',
  danger: '#dc2626',         // Red - errors/warnings
  dangerHover: '#b91c1c',
  warning: '#d97706',        // Orange - caution states
  warningHover: '#b45309',
  
  // Borders and shadows - Subtle depth
  border: '#000000', // Black border for retro theme
  borderLight: '#333333', // Dark gray light border
  shadow: 'rgba(0, 0, 0, 0.2)', // Darker shadow for retro theme
  shadowHover: 'rgba(0, 0, 0, 0.3)', // Even darker shadow on hover
  
  // Gradients - Keeping some gradient options, though solid colors might be more retro
  gradient: {
    primary: 'linear-gradient(135deg, #ffff00, #cccc00)', // Yellow gradient
    secondary: 'linear-gradient(135deg, #000000, #333333)' // Black/dark gray gradient
  }
}; 